import React from "react";
import {useSelector} from "react-redux";
import {AppState} from "../../../../store/store";
import {Spinner} from "../../../../atoms/spinner";
import {useSimilarResidents} from "./useSimilarResidents";

/** Component that defines the similar residents renderer. It's in charge of fetching similar residents. */
export const SimilarResidents = (): JSX.Element => {
  const organizationId = useSelector(
    (state: AppState) => state.adminSession?.user?.organization?.id,
  );
  const {isFetching} = useSimilarResidents(organizationId);

  if (isFetching) return <Spinner />;
  return null;
};
